// extracted by mini-css-extract-plugin
module.exports = {"filters":"SortingFilter_filters__rd3r1","subFilters":"SortingFilter_subFilters__k5XPr","filter":"SortingFilter_filter__Y4MSM","selected":"SortingFilter_selected__2v_bW"};